import React, { createContext, useState } from "react";
import { IntlProvider } from "react-intl";
import { translationMessages } from "../i18n";

export const Context = createContext({});

const Store = ({ children }) => {
  const [lang, setLang] = useState("en");
  const store = {
    lang: { get: lang, set: setLang }
  };
  return (
    <Context.Provider value={store}>
      <IntlProvider
        locale={lang || "en"}
        messages={translationMessages[lang || "en"]}
      >
        {children}
      </IntlProvider>
    </Context.Provider>
  );
};

export default Store;
